// extracted by mini-css-extract-plugin
module.exports = {"home":"ClientCustom_home__370nf","textFieldsAttr":"ClientCustom_textFieldsAttr__1FYv5","actionButton":"ClientCustom_actionButton__1EZHt","error":"ClientCustom_error__wCb3_"};